import { Box, Checkbox, CircularProgress, Container, CssBaseline, FormControlLabel, Grid, Modal, Paper, Table, TableBody, TableCell, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


let desc = '';
let entradaIn = '';
let salidaIn = '';

class PlanillaSV extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            checkInforme: {
                todo: true,
                reglamentaria: false,
                antiguedad: false,
                covid: false,
            },

            notificaciones: null,
            errores: null,
            todosInformes: [],
            todosInformes: [],
            reglamentaria: [],
            antiguedad: [],
            covid: [],
        }
        this.cambioListadoConsulta = this.cambioListadoConsulta.bind(this);
    }
    async componentDidMount(){
        this.setState({
            loading: true,
        });
        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_informesPlanilaSV.php`);
        const exito = await respuesta.json();
        this.setState({
            loading: false,
            errores: exito[0],
        })
        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                todosInformes: exito[1],
                reglamentaria: exito[2],
                antiguedad: exito[3],
                covid: exito[4],
            })
        }
    }

    render(){
        return (
            <>
                <Container>
                    <h3>Planilla</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    <br/>
                    <FormControlLabel label='Todo' control={<Checkbox checked={this.state.checkInforme.todo} onChange={this.cambioListadoConsulta} id='todo'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    <FormControlLabel label='Reglamentaria' control={<Checkbox checked={this.state.checkInforme.reglamentaria} onChange={this.cambioListadoConsulta} id='reglamentaria'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    {/*<FormControlLabel label='Antigüedad' control={<Checkbox checked={this.state.checkInforme.antiguedad} onChange={this.cambioListadoConsulta} id='antiguedad'  inputProps={{ 'aria-label': 'controlled' }} />  }/>*/}
                    <FormControlLabel label='Ex. Covid' control={<Checkbox checked={this.state.checkInforme.covid} onChange={this.cambioListadoConsulta} id='covid'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    {this.state.checkInforme.todo
                    ?
                        <Container>
                            <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                            </ReactHtmlTableToExcel>
                            <Table style={{marginTop: '1rem'}} sx={{maxWidth: '100%'}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell colSpan={4}></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}} colSpan={2}>A LIQUIDAR</StyledTableCell>
                                        <StyledTableCell colSpan={4}></StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCell>Concepto</StyledTableCell>
                                        <StyledTableCell>Ejercicio</StyledTableCell>
                                        <StyledTableCell>Nº</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>1er. Periodo</StyledTableCell>
                                        <StyledTableCell>2º Periodo</StyledTableCell>
                                        <StyledTableCell>Desde</StyledTableCell>
                                        <StyledTableCell>ANT.</StyledTableCell>
                                        <StyledTableCell>REG.</StyledTableCell>
                                        <StyledTableCell>COVID</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.todosInformes.map((name) => (
                                        <StyledTableRow key={name.idInformes}>
                                            <StyledTableCell>{name.tipoInforme}</StyledTableCell>
                                            <StyledTableCell>{name.ejercicio}</StyledTableCell>
                                            <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{name.primerPeriodo}</StyledTableCell>
                                            <StyledTableCell>{name.segundoPeriodo}</StyledTableCell>
                                            <StyledTableCell>{name.desde}</StyledTableCell>
                                            <StyledTableCell>{name.antiguedad}</StyledTableCell>
                                            <StyledTableCell>{name.reglamentaria}</StyledTableCell>
                                            <StyledTableCell>{name.covid}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Container>
                    :
                        null
                    }
                    {this.state.checkInforme.reglamentaria
                    ?
                        <Container>
                            <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                            </ReactHtmlTableToExcel>
                            <Table style={{marginTop: '1rem'}} sx={{maxWidth: '100%'}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell colSpan={4}></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}} colSpan={2}>A LIQUIDAR</StyledTableCell>
                                        <StyledTableCell colSpan={4}></StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCell>Concepto</StyledTableCell>
                                        <StyledTableCell>Ejercicio</StyledTableCell>
                                        <StyledTableCell>Nº</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>1er. Periodo</StyledTableCell>
                                        <StyledTableCell>2º Periodo</StyledTableCell>
                                        <StyledTableCell>Desde</StyledTableCell>
                                        <StyledTableCell>ANT.</StyledTableCell>
                                        <StyledTableCell>REG.</StyledTableCell>
                                        <StyledTableCell>COVID</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.reglamentaria.map((name) => (
                                        <StyledTableRow key={name.idInformes}>
                                            <StyledTableCell>{name.tipoInforme}</StyledTableCell>
                                            <StyledTableCell>{name.ejercicio}</StyledTableCell>
                                            <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{name.primerPeriodo}</StyledTableCell>
                                            <StyledTableCell>{name.segundoPeriodo}</StyledTableCell>
                                            <StyledTableCell>{name.desde}</StyledTableCell>
                                            <StyledTableCell>{name.antiguedad}</StyledTableCell>
                                            <StyledTableCell>{name.reglamentaria}</StyledTableCell>
                                            <StyledTableCell>{name.covid}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Container>
                    :
                        null
                    }
                    {this.state.checkInforme.antiguedad
                    ?
                        <Container>
                            <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                            </ReactHtmlTableToExcel>
                            <Table style={{marginTop: '1rem'}} sx={{maxWidth: '100%'}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell colSpan={4}></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}} colSpan={2}>A LIQUIDAR</StyledTableCell>
                                        <StyledTableCell colSpan={4}></StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCell>Concepto</StyledTableCell>
                                        <StyledTableCell>Ejercicio</StyledTableCell>
                                        <StyledTableCell>Nº</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>1er. Periodo</StyledTableCell>
                                        <StyledTableCell>2º Periodo</StyledTableCell>
                                        <StyledTableCell>Desde</StyledTableCell>
                                        <StyledTableCell>ANT.</StyledTableCell>
                                        <StyledTableCell>REG.</StyledTableCell>
                                        <StyledTableCell>COVID</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.antiguedad.map((name) => (
                                        <StyledTableRow key={name.idInformes}>
                                            <StyledTableCell>{name.tipoInforme}</StyledTableCell>
                                            <StyledTableCell>{name.ejercicio}</StyledTableCell>
                                            <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{name.primerPeriodo}</StyledTableCell>
                                            <StyledTableCell>{name.segundoPeriodo}</StyledTableCell>
                                            <StyledTableCell>{name.desde}</StyledTableCell>
                                            <StyledTableCell>{name.antiguedad}</StyledTableCell>
                                            <StyledTableCell>{name.reglamentaria}</StyledTableCell>
                                            <StyledTableCell>{name.covid}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Container>
                    :
                        null
                    }
                    {this.state.checkInforme.covid
                    ?
                        <Container>
                            <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                            </ReactHtmlTableToExcel>
                            <Table style={{marginTop: '1rem'}} sx={{maxWidth: '100%'}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell colSpan={4}></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}} colSpan={2}>A LIQUIDAR</StyledTableCell>
                                        <StyledTableCell colSpan={4}></StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCell>Concepto</StyledTableCell>
                                        <StyledTableCell>Ejercicio</StyledTableCell>
                                        <StyledTableCell>Nº</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>1er. Periodo</StyledTableCell>
                                        <StyledTableCell>2º Periodo</StyledTableCell>
                                        <StyledTableCell>Desde</StyledTableCell>
                                        <StyledTableCell>ANT.</StyledTableCell>
                                        <StyledTableCell>REG.</StyledTableCell>
                                        <StyledTableCell>COVID</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.covid.map((name) => (
                                        <StyledTableRow key={name.idInformes}>
                                            <StyledTableCell>{name.tipoInforme}</StyledTableCell>
                                            <StyledTableCell>{name.ejercicio}</StyledTableCell>
                                            <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{name.primerPeriodo}</StyledTableCell>
                                            <StyledTableCell>{name.segundoPeriodo}</StyledTableCell>
                                            <StyledTableCell>{name.desde}</StyledTableCell>
                                            <StyledTableCell>{name.antiguedad}</StyledTableCell>
                                            <StyledTableCell>{name.reglamentaria}</StyledTableCell>
                                            <StyledTableCell>{name.covid}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Container>
                    :
                        null
                    }
                    <br/>
                </Container>
            </>
        )
    }

    cambioListadoConsulta(e){
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
        });

        if(clave === 'todo'){
            if(valor){
                this.setState({
                    checkInforme: {
                        todo: true,
                        reglamentaria: false,
                        antiguedad: false,
                        covid: false,
                    }
                })
            }
        }else if(clave === 'reglamentaria'){
            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        reglamentaria: true,
                        antiguedad: false,
                        covid: false,
                    }
                })
            }
        }else if(clave === 'antiguedad'){
            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        reglamentaria: false,
                        antiguedad: true,
                        covid: false,
                    }
                })
            }
        }else if(clave === 'covid'){
            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        reglamentaria: false,
                        antiguedad: false,
                        covid: true,
                    }
                })
            }
        }
    }
}

export default PlanillaSV